import { cn } from '@/lib/utils';

type DamageStatBoxProps = {
	label: string;
	count: number;
	colorType: 'crit' | 'high' | 'med' | 'low';
};
export const DamageStatBox = ({ colorType, count, label }: DamageStatBoxProps) => {
	const containerClassMapping = {
		'bg-red-50 border-red-100 dark:bg-red-950 dark:border-red-950': colorType === 'crit',
		'bg-orange-50 border-orange-100 dark:bg-yellow-950 dark:border-yellow-950': colorType === 'high',
		'bg-yellow-50 border-yellow-100 dark:bg-yellow-800 dark:border-yellow-800': colorType === 'med',
		'bg-blue-50 border-blue-100 dark:bg-blue-950 dark:border-blue-950': colorType === 'low',
	};
	const textMapping = {
		'text-red-600': colorType === 'crit',
		'text-orange-600 dark:text-yellow-600': colorType === 'high',
		'text-yellow-600 dark:text-yellow-500': colorType === 'med',
		'text-blue-600': colorType === 'low',
	};
	const dimmedTextMapping = {
		'text-muted-foreground! font-normal!': count <= 0,
	};
	const dimmedContainerMapping = {
		'bg-muted! border-border!': count <= 0,
	};

	return (
		<div className={cn('rounded border', containerClassMapping, dimmedContainerMapping)}>
			<div className={cn('text-sm font-extrabold', textMapping, dimmedTextMapping)}>{count}</div>
			<div className={cn('text-[10px] uppercase font-semibold', textMapping, dimmedTextMapping)}>{label}</div>
		</div>
	);
};
